import { useEffect, useState } from "react";
import { useQuery } from "react-query";
import { toast } from "react-toastify";
import BlogService from "../../../services/API/BlogService";

import Pagination from "react-js-pagination";
import { Modal, Button } from "react-bootstrap";

export default function BlogCategory() {
    const [page, setPage] = useState(1);
    const [myData, setMyData] = useState([]);
    const [id, setId] = useState(null);
    const [edit, setEdit] = useState(false);
    const [show, setShow] = useState(false);
    const [add, setAdd] = useState(false);
    const [categoryName, setCategoryName] = useState(null);
    const [displaySearchField, setDisplaySearchField] = useState(false);
    const [searchkey, setSearchkey] = useState(null);
    const [del, setDel] = useState(false);
    const [reason, setReason] = useState("");
    const [row_no, setNo] = useState("");

    const postsPerPage = 20;

    const handlePageChange = (pageNumber) => {
        setPage(pageNumber);
    };

    const queryKey = "api/blog-category";
    const {
        data: cateList,
        isLoading: loading,
        isSuccess: success,
        isFetching,
        refetch,
    } = useQuery([queryKey], BlogService.getBlogCategory, {
        refetchOnWindowFocus: false,
        keepPreviousData: true,
    });
    const indexOfLastPost = page * postsPerPage;
    const indexOfFirstPost = indexOfLastPost - postsPerPage;
    const cateLists = Array.isArray(myData)
        ? myData?.slice(indexOfFirstPost, indexOfLastPost)
        : cateList?.data?.slice(indexOfFirstPost, indexOfLastPost);

    useEffect(() => {
        if (cateList?.data) {
            window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
            setMyData(cateList?.data);
        }
    }, [cateList]);

    useEffect(() => {
        window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
    }, [page]);

    const handleAdd = () => {
        setAdd(true);
        setCategoryName(null);
    };

    const handleEdit = async (blog) => {
        try {
            const blogData = await BlogService.editBlogCategory(
                blog?.id
            );

            setId(blog?.id);
            setEdit(blogData?.data);
            if (blogData?.data) {
                setShow(true);
            }
        } catch (er) {
            toast.error(er);
        }
    };

    useEffect(() => {
        if (edit) {
            setCategoryName(edit?.category_name);
        }
    }, [edit]);

    const submitForm = () => {
        if (edit) {
            updateCategory();
        }
    };

    const submitAddForm = () => {
        addBlogCategory();
    }

    const handleHide = () => {
        setAdd(false);
        setShow(false);
        setCategoryName(null);
    };

    const addBlogCategory = async () => {
        const payload = {
            category_name: categoryName,
        };
        let staticContent = true
        const error = validateBlogCategory(payload, staticContent);
        if (error) {
            toast.error(error);
            return;
        }
        try {
            const response = await BlogService.addBlogCategory(
                payload
            );
            if (response) {
                toast.success("Blog Category created successfully");
                handleHide();
                if (searchkey) {
                    handleSearch({ target: { value: searchkey } }, 1);
                } else {
                    refetch();
                }
                setImmediate(null);
            }
        } catch (e) {
            toast.error(e);
        }
    };

    const updateCategory = async () => {
        const payload = {
            category_name: categoryName,
        };
        let staticContent = true
        const error = validateBlogCategory(payload, staticContent);
        if (error) {
            toast.error(error);
            return;
        }
        try {
            const response = await BlogService.updateBlogCategory(
                edit?.id,
                payload
            );
            if (response) {
                toast.success("Blog Category updated successfully");
                handleHide();
                if (searchkey) {
                    handleSearch({ target: { value: searchkey } }, 1);
                } else {
                    refetch();
                }
                setImmediate(null);
            }
        } catch (e) {
            toast.error(e);
        }
    };

    const validateBlogCategory = (data, staticContent = false) => {
        if (!data.category_name) return "Please enter blog category name";
    };

    const handleSearch = async (e, page) => {
        const value = e.target.value;
        setSearchkey(value);
        const payload = { category_name: value };
        const { data } = await BlogService.searchBlogCategory(payload);
        window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
        if (!page) {
            setPage(1);
        }
        setMyData(data);
    };

    const clearFilter = () => {
        setDisplaySearchField(false);
        setSearchkey(null);
        setCategoryName(null);
        setMyData(cateList);
        setPage(1)
    };

    const handleDelete = async (cate) => {
        const status = cate.status === 1 ? 0 : 1;
        const menu = 'Blog Category';
        try {
            await BlogService.deactivateBlogCategory(cate?.id, {
                status, reason, menu, row_no
            });
            const message =
                cate?.status === 1
                    ? "Blog Category Deactivated Successfully"
                    : "Blog Category Activated Successfully";
            toast.success(message);
            setDel(null);
            refetch();
        } catch (er) {
            toast.error(er);
        }
    };

    return (
        <div style={{ borderTop: "0px", paddingTop: "30px" }}>
            <div
                style={{
                    paddingTop: "30px",
                }}
                className="d-flex justify-content-end align-items-center gap-2 p-2"
            >
                {cateList?.length !== myData?.length && (
                    <button
                        type="button"
                        className="button_new pull-right"
                        onClick={clearFilter}
                    >
                        Clear Filters
                    </button>
                )}
                {displaySearchField ? (
                    <input
                        type="text"
                        className="button_new pull-right "
                        value={searchkey}
                        onChange={handleSearch}
                        placeholder="Search"
                    />
                ) : (
                    <a
                        className=" button_new pull-right"
                        onClick={() => {
                            setDisplaySearchField(true);
                        }}
                        onKeyDown={() => {
                            setDisplaySearchField(true);
                        }}
                    >
                        <i
                            class="fa fa-search requests-icons"
                            aria-hidden="true"
                            title="Search"
                        ></i>
                    </a>
                )}
                <a
                    className=" button_new pull-right"
                    onClick={() => handleAdd()}
                    onKeyDown={() => handleAdd()}
                    title="Add Blog Category"
                >
                    <i className="fa fa-plus fa-fw requests-icons"></i>
                </a>
            </div>
            <div className="table-responsive ">
                <table className="table table-bordered table-hover dataTable no-footer" style={{ tableLayout: "fixed" }}>
                    <thead>
                        <tr role="row" style={{ fontWeight: 700 }}>
                            <th className="text-center" width="34px">
                                S. No.
                            </th>
                            <th className="text-center">Blog Category</th>
                            <th className="text-center" width="50px">
                                Actions
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        {cateLists?.length !== 0 ? (
                            cateLists?.map((cate, index) => {
                                return (
                                    <tr key={cate?.id}>
                                        <td className="text-start align-middle">
                                            {postsPerPage * (page - 1) + index + 1}
                                        </td>
                                        <td className="text-start align-middle">
                                            {cate?.category_name}
                                        </td>


                                        <td className="text-start align-middle">
                                            <a
                                                title="Add"
                                                onClick={() => handleEdit(cate)}
                                                onKeyDown={() => handleEdit(cate)}
                                            >
                                                <i className="fa fa-edit fa-fw cursor-pointer"></i>
                                            </a>
                                            {cate?.status === 1 ? (
                                                <i
                                                    className="fa fa-circle fa-fw txt-success pe-auto"
                                                    style={{
                                                        cursor: "pointer",
                                                    }}
                                                    title="Deactivate"
                                                    onClick={() => { setDel(cate); setReason(""); setNo(postsPerPage * (page - 1) + index + 1) }}
                                                    onKeyDown={() => setDel(cate)}
                                                ></i>
                                            ) : (
                                                <i
                                                    className="fa fa-circle fa-fw txt-fail"
                                                    title="Activate"
                                                    style={{
                                                        cursor: "pointer",
                                                    }}
                                                    onClick={() => { setDel(cate); setReason(""); setNo(postsPerPage * (page - 1) + index + 1) }}
                                                    onKeyDown={() => setDel(cate)}
                                                ></i>
                                            )}
                                        </td>
                                    </tr>
                                );
                            })
                        ) : (
                            <tr>
                                <td colSpan={3} className="p-2 text-center">
                                    {loading || isFetching
                                        ? "Loading..."
                                        : "No data found"}
                                </td>
                            </tr>
                        )}
                    </tbody>
                </table>
                {myData.length > postsPerPage && (
                    <Pagination
                        activePage={page}
                        itemsCountPerPage={postsPerPage}
                        totalItemsCount={myData.length}
                        pageRangeDisplayed={postsPerPage}
                        onChange={handlePageChange}
                    />
                )}
            </div>
            {show && (
                <Modal
                    show={show}
                    animation={false}
                    onHide={handleHide}
                    dialogClassName="modal-md"
                >
                    <Modal.Header closeButton>
                        <h3 className="modal-title">Edit Blog Category</h3>
                    </Modal.Header>
                    <Modal.Body
                        // style={{ height: "20vh", overflowY: "scroll" }}
                    >
                        <div className="form-group">
                            <label htmlFor="tags">
                                {" "}
                                Category Name{" "}
                                <span style={{ color: "red" }}> *</span>
                            </label>
                            <input
                                type="text"
                                className="form-control mb-3"
                                placeholder="Enter Category Name"
                                value={categoryName}
                                onChange={(e) => setCategoryName(e.target.value)}
                            />
                        </div>
                    </Modal.Body>
                    <Modal.Footer>
                        <button
                            type="button"
                            className="btn button_new_success"
                            onClick={submitForm}
                        >
                            Save
                        </button>
                    </Modal.Footer>
                </Modal>
            )}
            {add && (
                <Modal
                    show={add}
                    animation={false}
                    onHide={handleHide}
                    dialogClassName="modal-md"
                >
                    <Modal.Header closeButton>
                        <h3 className="modal-title">Add Blog Category</h3>
                    </Modal.Header>
                    <Modal.Body
                        // style={{ height: "20vh", overflowY: "scroll" }}
                    >
                        <div className="form-group">
                            <label htmlFor="tags">
                                {" "}
                                Category Name{" "}
                                <span style={{ color: "red" }}> *</span>
                            </label>
                            <input
                                type="text"
                                className="form-control mb-3"
                                placeholder="Enter Category Name"
                                value={categoryName}
                                onChange={(e) => setCategoryName(e.target.value)}
                            />
                        </div>
                    </Modal.Body>
                    <Modal.Footer>
                        <button
                            type="button"
                            className="btn button_new_success"
                            onClick={submitAddForm}
                        >
                            Save
                        </button>
                    </Modal.Footer>
                </Modal>
            )}
            <Modal
                show={!!del}
                onHide={() => setDel(null)}
                animation={false}
                centered
            >
                <Modal.Header closeButton>
                    <Modal.Title>Are you Sure?</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <p>
                        Do you want to {del?.status === 1 ? "deactivate " : "activate "}
                        this document?
                    </p>

                    {/* 13-Aug-2024 Karthikeyan p1 status log start */}
                    <div>
                        <p><label for="w3review">Reason <span style={{ color: "red" }}> *</span></label></p>
                        <textarea
                            id="w3review"
                            placeholder="Reason"
                            value={reason}
                            onChange={(e) => setReason(e.target.value)}
                            style={{ width: "100%" }}
                            maxLength={500}
                        />
                    </div>
                    {/* 13-Aug-2024 Karthikeyan p1 status log end */}
                    <div className="d-flex gap-3 justify-content-end">
                        <Button
                            variant="danger"
                            className="px-3 py-2"
                            onClick={() => setDel(null)}
                        >
                            No
                        </Button>
                        <Button
                            variant="success"
                            className="px-3 py-2"
                            onClick={() => handleDelete(del)}
                            disabled={!reason}
                        >
                            Yes
                        </Button>
                    </div>
                </Modal.Body>
            </Modal>
        </div>
    );
}
